import type {Fond, Record} from 'typings/portaro.be.types';

export class RecordCopyRequest {
    public constructor(public readonly source: Record, public readonly targetFond: Fond) {
    }
}